import { Injectable } from '@angular/core';
import { AppStorageService } from '../../services/app-storage/app-storage.service';
import { Observable, of } from 'rxjs';
import { Router, UrlTree } from '@angular/router';
import { GuardHelper } from '../../helpers/guard-helper/guard-helper';

@Injectable({
    providedIn: 'root',
})
export class HasVisitedGoOverviewGuard {
    constructor(
        private readonly localStorageService: AppStorageService,
        private readonly router: Router,
    ) {}

    // Users who have not viewed the Go Overview page should be redirected to it
    canActivate(): Observable<boolean | UrlTree> {
        const hasViewedGoOverview =
            this.localStorageService.getHasViewedGoOverview();
        if (hasViewedGoOverview) {
            return of(true);
        } else {
            return GuardHelper.getGoOverviewUrl(this.router);
        }
    }
}
